var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_428_4195",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_428_4195)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0199 11.4375L6.70737 14.7708C6.48515 14.9931 6.24209 15.0972 5.9782 15.0833C5.71431 15.0694 5.47126 14.9514 5.24903 14.7292C5.0407 14.5069 4.94001 14.2674 4.94695 14.0104C4.9539 13.7535 5.06153 13.5139 5.26987 13.2917L8.5407 10L5.2282 6.64584C5.01987 6.42362 4.91917 6.18403 4.92612 5.92709C4.93306 5.67014 5.0407 5.43056 5.24903 5.20834C5.47126 4.98612 5.71778 4.87153 5.98862 4.86459C6.25945 4.85764 6.50598 4.96528 6.7282 5.18751L10.0199 8.52084L13.2907 5.18751C13.5129 4.96528 13.7595 4.85764 14.0303 4.86459C14.3011 4.87153 14.5476 4.98612 14.7699 5.20834C14.9782 5.43056 15.0789 5.67014 15.072 5.92709C15.065 6.18403 14.9574 6.42362 14.749 6.64584L11.4574 10L14.749 13.3125C14.9574 13.5208 15.065 13.7535 15.072 14.0104C15.0789 14.2674 14.9782 14.5069 14.7699 14.7292C14.5476 14.9514 14.3011 15.066 14.0303 15.0729C13.7595 15.0799 13.5129 14.9722 13.2907 14.75L10.0199 11.4375Z",
    fill: "#FF0505"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedCross);
export default __webpack_public_path__ + "static/media/redCross.454803284931eead02203a021929dfaa.svg";
export { ForwardRef as ReactComponent };